export const orderBookTime = 5;
export const statsTime = 5;
export const recentMarketTime = 10;
export const orderBook = 10;
